import reducer from './reducer';
import saga from './saga';

export { saga, reducer };



// WEBPACK FOOTER //
// ./src/store/modules/window/index.ts